// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"CircularSpinner_loaderWrapper__1t7Xb"};